import React from "react";
import { Grid, Dialog, Button } from "../../../../../../";
import { makeStyles } from "@material-ui/styles";
import { Typography, Divider } from "@material-ui/core";
var useStyles = makeStyles(function (theme) {
  return {
    containerButtonsAttendance: {
      marginTop: "16px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-around"
    },
    containerActions: {
      marginTop: "32px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between"
    }
  };
});

var MobileDialogCampusCalendarCheckinInjured = function MobileDialogCampusCalendarCheckinInjured(props) {
  var classes = useStyles();
  return /*#__PURE__*/React.createElement(Dialog, {
    fullWidth: true,
    open: props.open,
    onClose: props.onClose
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    align: "center"
  }, props.translation ? props.translation.title || "Check In" : "Check In"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    align: "center"
  }, props.data ? props.data.name || "" : "")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Divider, null)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, props.translation ? props.translation.labels ? props.translation.labels.injured || "Is he/she still injured?" : "Is he/she still injured?" : "Is he/she still injured?")), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    className: classes.containerActions
  }, /*#__PURE__*/React.createElement(Button, {
    size: "medium",
    color: "secondary",
    variant: "outlined",
    onClick: props.handleNo
  }, props.translation ? props.translation.buttons ? props.translation.buttons.no || "No" : "No" : "No"), /*#__PURE__*/React.createElement(Button, {
    type: "button",
    size: "medium",
    className: classes.mr30,
    color: "primary",
    variant: "outlined",
    onClick: props.handleYes
  }, props.translation ? props.translation.buttons ? props.translation.buttons.yes || "Yes" : "Yes" : "Yes"))));
};

export { MobileDialogCampusCalendarCheckinInjured };